import navigation from "@/lang/fil/navigation";
import generics from "@/lang/fil/generics";
import questions from "@/lang/fil/questions";
import a11y from "@/lang/fil/a11y";
import velt from "@/lang/fil/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
